import React, { useState } from 'react';
import { useNavigate  , Link} from 'react-router-dom';

//URL
import {URL} from '../../../context/URL'

//sweetAlrt 
import {SweetAlrt} from '../../../context/SweetAlrt'

//Incript_password
import {Incript_password} from '../../../context/Incript_password'

//GoogleLogin
import { GoogleLogin } from '@react-oauth/google';
import Jwt_decode from 'jwt-decode';

//mui
import { Typography , Alert , styled  , TextField} from '@mui/material'


//css
const AlrtBox = styled(Typography)(({theme})=>({
    color:'red',
    marginTop:'-18px',
    marginBottom:'5px',
    paddingLeft:'40px',
    fontSize:'15px',
    "@media (max-width:390px) ":{
        fontSize:'10px'
    }
 }))

 //main function 
export default function Email_verifiy() {
    
    const navigate = useNavigate();
    
    const [email , setEmail] = useState("");
    const [emailAlrt , setEmailAlrt] = useState(false);
    const [checkUser , setCheckUser] = useState(false);



    //logIn with google
    const onUser_Login_Success = async(res)=>{
        console.log("succes");

        const All_data = Jwt_decode(res.credential)

        const data = {
            name : All_data.name,
            email : All_data.email,
            password : All_data.sub
        }

        


         try{
            let result = await fetch(`${URL}/user/getUser/${data.email}`);
            result =await result.json();

            if(result.length == 0){
                setCheckUser(false);
                try{
                    let incript_password = Incript_password(data.password);
                     let result = await fetch(`${URL}/user/register` , {
                         method:"POST",
                     body : JSON.stringify({name : data.name ,email :data.email ,  password:incript_password}),
                     headers : {
                         "content-type" : "application/json"
                     }
                     })
        
                     SweetAlrt('Sign in ' , "success")
                     localStorage.setItem('User' , JSON.stringify({name : data.name ,email :data.email ,  password:incript_password}))
                     navigate('/Home');
                 }catch(error){
                    SweetAlrt('Sign in ' , "error")
                     console.log('post api error : ' + error)
                 }
              
            }else{
             setCheckUser(true);
            console.log("user alrady login")
            }
         }catch(error){
             console.log("user find aip error : " + error);
         }

        
    }

    const onUser_Login_Error = (res)=>{
        console.log("Eror");
    }

    const handle_confrom = async()=>{
        
       

        //email validation
        let emailPatten = "([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|\"\(\[\]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(\.[!#-'*+/-9=?A-Z^-~-]+)*|\[[\t -Z^-~]*])"
        let rEmail = new RegExp(emailPatten);

        if(rEmail.test(email)){
            setEmailAlrt(false);
        }else{
            setEmailAlrt(true)
        }

        if(!emailAlrt){
            if(rEmail.test(email)){
                try{
                   let result = await fetch(`${URL}/user/getUser/${email}`);
                   result =await result.json();
                   console.log("done");
                   if(result.length == 0){
                       setCheckUser(false);
                      
                       SweetAlrt("OTP send "  ,  "success")  
                    navigate(`/OTP/SignUp/${email}`)
                   }else{
                    setCheckUser(true);
                   }
                }catch(error){
                    console.log("user find aip error : " + error);
                }
            }
        }
    }

  return (
    <>
        
    <div className="container" style={{background :'#f2f2f2'}}>
        <div className="wrapper" style={{margin:'0px' , background :  '#FFFF'}}>
            <div className="title"><span>SignUp Form</span></div>

            <div >
            {
              checkUser &&   <Alert severity="error" style={{margin : '1rem 1rem 0rem 1rem'}}>This email id Alredy using !</Alert>
            }
            </div>

            <form>
            {/* <div className="row">
                <i className="fas fa-envelope"></i>
                <input type="email" placeholder="Email " onChange={(e)=>setEmail(e.target.value)} required/>
            </div>
            {
                    emailAlrt && <AlrtBox>* email is abc@gmail.com</AlrtBox>
            } */}

            <div style={{marginBottom : '1rem'}}>
                {
                    emailAlrt ?  <TextField
                    error
                    color='info'
                    style={{width : '100%'}}
                    id="outlined-error"
                    label="Email"
                    onChange={(e)=>setEmail(e.target.value)}
                    helperText="invaild email"
                    /> 
                    :
                    <TextField
                        // error
                        color='info'
                        style={{width : '100%'}}
                        id="outlined-error"
                        label="Email"
                        onChange={(e)=>setEmail(e.target.value)}
                    />
                }
             </div>


            
            <div className="row button"onClick={handle_confrom}>
                <input type="button"  value="Send OTP"  />
            </div>
            
            <p style={{textAlign : 'center'}}>----------- OR ---------</p>

            <div style={{display: 'flex' , justifyContent: 'center' , width : '100%'}}>
                <GoogleLogin
                    onSuccess={(res)=>onUser_Login_Success(res)}
                    onError={(res)=>onUser_Login_Error(res)}
                />
            </div>
            </form>
        </div>
        </div>
    </>
  )
}
